module.exports = __webpack_public_path__ + "img/Ticket-Star.af35d6ba.svg";